import { SellerOptionsModel } from '@/__generated';
import { apiSdk } from '@/httpClient';
import { Select, SelectProps } from 'antd';
import React from 'react';

// Caisses et caissiers de la compagnie (filtres « Caisse » et « Caissier » des réservations et du rapport des ventes).
let cached: Promise<SellerOptionsModel> | undefined;
const loadOptions = () => {
  cached = cached || apiSdk.BookingDetailService.sellerOptions().catch(e => {
    cached = undefined;
    throw e;
  });
  return cached;
};

interface Props extends SelectProps<any> {
  kind: 'register' | 'cashier';
}
export default function SellerInput({ kind, ...props }: Props) {
  const [items, setItems] = React.useState<Array<{ id: string; label: string }>>([]);

  React.useEffect(() => {
    loadOptions().then(res => {
      setItems(
        kind === 'register'
          ? (res.registers || []).map(r => ({ id: r.id || '', label: r.stationName ? `${r.name} (${r.stationName})` : r.name || '' }))
          : (res.cashiers || []).map(c => ({ id: c.id || '', label: c.name || '' })),
      );
    });
  }, [kind]);

  return (
    <Select
      maxTagCount="responsive"
      allowClear
      {...props}
      filterOption={(input, option) => (option?.children as any)?.toLowerCase().includes(input.toLowerCase())}
      showSearch={true}
    >
      {items.map(c => (
        <Select.Option key={c.id} value={c.id}>
          {c.label}
        </Select.Option>
      ))}
    </Select>
  );
}
